import { render, staticRenderFns } from "./sectionItem.vue?vue&type=template&id=73014079&"
import script from "./sectionItem.vue?vue&type=script&lang=js&"
export * from "./sectionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports